<div id="information-modal">
    <header class="header-modal">
        <h1 class="title-modal">{{ data.title }} <span (click)="closeModal()" class="close-modal">X</span></h1>
    </header>
    
    <div class="center-vertical">

        <div>
            <div class="text-center" *ngIf="data.icon">
                <mat-icon class="size-icon">{{ data.icon }}</mat-icon>
            </div>
            
            <div class="text-center mt-16">
                <p class="message-info">{{data.message}}</p>
            </div>
        </div>

    </div>

</div>
